import { lazyLoadView } from "@router/routes";

export default [
  {
    path: "/page2",
    name: "page2",
    component: () => lazyLoadView(import("@views/page2/page2"))
  }
];
